<template>
  <div class="hyp-grid-content-container" v-if="profileInfo">
    <div class="hyp-grid-profile-container">
      <div>
        <span
          v-if="profileInfo && profileInfo.title"
          class="details-heading application-heading mb-4"
          v-html="profileInfo.title"
        ></span>
        <div class="font-italic text-caption" v-if="profileInfo.updatedAt">
          {{ getFormattedDate(profileInfo.updatedAt) }}
        </div>
        <div class="clearfix"></div>
      </div>
      <v-row v-if="profileInfo && profileInfo.body">
        <v-col
          cols="12"
          ref="bodyProfile"
          v-html="getCleanBody(profileInfo.body)"
          class="pt-3 content-container"
        ></v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { addTargetToLinks } from "@/common/basic.utilities";
import { getFormatted } from "@/common/date.utilities";

export default {
  name: "GlobalIssuesProfile",
  props: {
    profileInfo: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getCleanBody(body) {
      return body ? addTargetToLinks(body) : "";
    },
    getFormattedDate(date) {
      return date ? getFormatted(date) : null;
    },
  },
};
</script>

<style scoped>
.details-heading {
  font-size: 20px;
}
.hyp-grid-profile-container .content-container {
  max-height: 78vh;
  overflow-y: auto;
}
</style>
